import { render, staticRenderFns } from "./newKeyWordStatistics.vue?vue&type=template&id=4a306b0e&scoped=true&"
import script from "./newKeyWordStatistics.vue?vue&type=script&lang=js&"
export * from "./newKeyWordStatistics.vue?vue&type=script&lang=js&"
import style0 from "./newKeyWordStatistics.vue?vue&type=style&index=0&id=4a306b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a306b0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a306b0e')) {
      api.createRecord('4a306b0e', component.options)
    } else {
      api.reload('4a306b0e', component.options)
    }
    module.hot.accept("./newKeyWordStatistics.vue?vue&type=template&id=4a306b0e&scoped=true&", function () {
      api.rerender('4a306b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/newKeyWordStatistics.vue"
export default component.exports